<template>
  <div class="container" v-if="!isToPage">
    <div class="handle-wrapper">
      <div class="handle-left">
        <!-- <Input
          v-model="searchText"
          search
          placeholder="搜索客户..."
          @on-change="searchSales"
          clearable
          icon="ios-search"
          style="width: 250px; margin-right: 20px"
        ></Input> -->
        <DatePicker
          type="month"
          v-model="pickM"
          @on-change="dateChange"
          placeholder="选择年、月"
          style="width: 200px"
        ></DatePicker>
        <div class="my-sum">
          我的合计：计划销量{{
            salesStatSum.estSalesVolume ? salesStatSum.estSalesVolume : ""
          }}吨，实际销量{{
            salesStatSum.salesVolume ? salesStatSum.salesVolume : ""
          }}吨，完成率XX%，计划回款{{
            salesStatSum.estReceive ? salesStatSum.estReceive : ""
          }}元，实际回款{{ salesStatSum.receive }}元，完成率XX%
        </div>
      </div>
      <div class="handle-right"></div>
    </div>
    <div class="table">
      <!-- 销量 -->
      <div class="table-wrapper" ref="tableWrapper">
        <div class="title">
          <div class="title-left">
            <div>销量计划</div>
          </div>
          <div class="title-right">
            <span>共{{ volTotalCounts }}条</span>
            <Page
              :total="volTotalCounts"
              :page-size="15"
              @on-change="loadSalesStatVol"
              show-total
              simple
              style="margin-right: 24px"
            />
            <Button size="small" type="info" @click="toEditPage('sales')"
              >修改</Button
            >
          </div>
        </div>
        <Table
          :columns="volColumns"
          :data="salesStatVol"
          :height="tableHeight"
        ></Table>
      </div>
      <!-- 回款 -->
      <div class="table-wrapper" ref="tableWrapper">
        <div class="title">
          <div class="title-left">
            <div>回款计划</div>
          </div>
          <div class="title-right">
            <span>共{{ receiveTotalCounts }}条</span>
            <Page
              :total="receiveTotalCounts"
              :page-size="15"
              @on-change="loadSalesStatReceive"
              show-total
              simple
              style="margin-right: 24px"
            />
            <Button size="small" type="info" @click="toEditPage('receive')"
              >修改</Button
            >
          </div>
        </div>
        <Table
          :columns="receiveColumns"
          :data="receiveList"
          :height="tableHeight"
        ></Table>
      </div>
    </div>
  </div>
  <router-view v-else />
</template>


<script>
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";
import dayjs from "dayjs";

export default {
  name: "SalesPlan",
  data() {
    return {
      page: 0,
      receivePage: 0,
      tableHeight: 300,
      searchText: null,
      volIndexFile: null,
      volFile: null,
      editVol: null,
      pickM: new Date(),
      allEdit: false,
      receiveList: [],
      volColumns: [
        {
          title: "销售项目",
          key: "sales",
          minWidth: 100,
          render: (h, params) => h("span", params.row.abbr),
        },
        {
          title: "计划销量(吨)",
          key: "estSalesVolume",
          align: "right",
          render: (h, params) =>
            h(
              "span",
              params.row.salesStat ? params.row.salesStat.estSalesVolume : "-"
            ),
          minWidth: 100,
        },
        {
          title: "实际销量(吨)",
          key: "salesVolume",
          align: "right",
          minWidth: 100,
          render: (h, params) => h("span", ""),
        },
        {
          title: "完成率",
          key: "date",
          minWidth: 90,
          align: "right",
          render: (h, params) => h("span", params.row.salesPrice),
        },
        {
          title: "负责人",
          minWidth: 90,
          key: "salesPerson",
          align: "right",
          render: (h, params) => h("span", params.row.salesPrice),
        },
      ],
      receiveColumns: [
        {
          title: "客户",
          key: "sales",
          minWidth: 160,
          render: (h, params) => h("span", params.row.name),
        },
        {
          title: "计划回款(元)",
          minWidth: 100,
          key: "date",
          align: "right",
          render: (h, params) =>
            h(
              "span",
              params.row.salesStat ? params.row.salesStat.estReceive : "-"
            ),
          minWidth: 100,
        },
        {
          title: "实际回款(元)",
          minWidth: 100,
          key: "date",
          align: "right",
          render: (h, params) => h("span", ""),
        },
        {
          title: "完成率",
          minWidth: 90,
          key: "date",
          align: "right",
          render: (h, params) => h("span", params.row.salesPrice),
        },
        {
          title: "负责人",
          minWidth: 90,
          key: "salesPerson",
          align: "right",
          render: (h, params) => h("span", params.row.salesPrice),
        },
      ],
      isToPage: false,
    };
  },
  watch: {
    // 监听路由的切换
    "$route.path": function (n, o) {
      if (n === "/home/salesPlan") {
        this.isToPage = false;
      }
    },
  },
  computed: {
    ...mapState({
      salesStatVol: (state) => state.salesStat.salesStatVol,
      salesStatReceive: (state) => state.salesStat.salesStatReceive,
      volTotalCounts: (state) => state.salesStat.volTotalCounts,
      receiveTotalCounts: (state) => state.salesStat.receiveTotalCounts,
      salesStatSum: (state) => state.salesStat.salesStatSum,
    }),
  },
  methods: {
    ...mapActions({
      getSalesStatVol: "salesStat/getSalesStatVolAction",
      getSalesStatReceive: "salesStat/getSalesStatReceiveAction",
      getMySalesStatSum: "salesStat/getMySalesStatSumAction",
    }),
    async loadSalesStatVol(page) {
      try {
        let api = {
          skip: this.page * 15,
          limit: 15,
        };
        const date = dayjs(this.pickM).format("YYYY-MM").split("-");
        api.year = date[0];
        api.month = date[1];
        // this.tableLoading = true;
        await this.getSalesStatVol(api);
        // this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        // this.tableLoading = false;
      }
    },
    async loadSalesStatReceive(receivePage) {
      if (receivePage) this.receivePage = receivePage - 1;
      try {
        let api = {
          skip: this.receivePage * 15,
          limit: 15,
        };
        const date = dayjs(this.pickM).format("YYYY-MM").split("-");
        api.year = date[0];
        api.month = date[1];
        // this.tableLoading = true;
        const data = await this.getSalesStatReceive(api);
        this.receiveList = data.customerList;
        // this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        // this.tableLoading = false;
      }
    },
    async loadMySalesStatSum(page) {
      try {
        let api = {};
        const date = dayjs(this.pickM).format("YYYY-MM").split("-");
        api.year = date[0];
        api.month = date[1];
        // this.tableLoading = true;
        await this.getMySalesStatSum(api);
        // this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        // this.tableLoading = false;
      }
    },
    dateChange() {
      this.loadSalesStatVol();
      this.loadSalesStatReceive();
      this.loadMySalesStatSum();
    },
    // searchSales() {},

    toEditPage(page) {
      this.isToPage = true;
      const date = dayjs(this.pickM).format("YYYY-MM").split("-");
      if (page === "sales") {
        this.$router.push({
          name: "salesPlanVol",
          query: {
            year: date[0],
            month: date[1],
          },
        });
      } else {
        this.$router.push({
          name: "salesPlanReceive",
          query: {
            year: date[0],
            month: date[1],
          },
        });
      }
    },
  },
  created() {
    this.loadMySalesStatSum();
    this.loadSalesStatVol();
    this.loadSalesStatReceive();
  },

  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
    if (
      this.$route.path === "/home/salesPlan/edit_salesPlan" ||
      this.$route.path === "/home/salesPlan/edit_receivePlan"
    ) {
      this.isToPage = true;
    }
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

.handle-left
  display flex

.my-sum
  margin auto 15px
  font-size 16px

.table
  display flex
  justify-content space-between
  height calc(100% - 48px)

.table-wrapper
  width 49%
  height calc(100% - 48px)

  .title
    display flex
    justify-content space-between

    .title-left
      font-size 18px

    .title-right
      display flex
      align-items center
      justify-content flex-end
</style>